import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  availableSpotsKeys,
  getMyCondominiums,
} from '../api/available-spots';
import { useAuthStore } from '../stores/authStore';

export function useCurrentCondominium() {
  const userDoc = useAuthStore((s) => s.userDoc);
  const isGlobalAdmin = userDoc?.isGlobalAdmin ?? false;

  const query = useQuery({
    queryKey: availableSpotsKeys.condominiums(isGlobalAdmin),
    queryFn: getMyCondominiums,
    enabled: !!userDoc,
    staleTime: 5 * 60 * 1000,
  });

  const condominiums = query.data ?? [];

  const condominium = useMemo(() => {
    if (condominiums.length === 0) return null;

    const slug = userDoc?.lastSelectedTenantSlug;
    if (slug) {
      const match = condominiums.find((item) => item.slug === slug);
      if (match) return match;
    }

    return condominiums[0] ?? null;
  }, [condominiums, userDoc?.lastSelectedTenantSlug]);

  const label = useMemo(() => {
    if (query.isLoading) return null;
    if (condominium) return condominium.name;
    if (isGlobalAdmin) return 'Administrador global';
    return 'Sem condomínio associado';
  }, [query.isLoading, condominium, isGlobalAdmin]);

  return {
    condominium,
    condominiums,
    label,
    isLoading: query.isLoading,
    canSwitch: condominiums.length > 1,
  };
}
